module.exports = __webpack_public_path__ + "img/1517-cup.77cf6034.png";